export const selectCountries = state => state.global.countries;
export const selectRiskLevelLabels = state => state.global.riskLevels?.riskLevelLabels || [];
export const selectUsersToAssign = state => state.global.usersToAssign;
export const selectDefaultScreeningProfile = state => state.global.defaultScreeningProfile;
export const selectDocumentTypes = state => state.global.packagesTypes;
export const selectCurrencies = state => state.global.currencies;
export const selectNotifications = state => state.global.notifications;
